export const entities = [];
export const defaultFlipperSpeedMultiplier = 400;
//@ts-ignore
window.debug = { entities };
export var GamePhase;
(function (GamePhase) {
    GamePhase[GamePhase["MenuScreen"] = 0] = "MenuScreen";
    GamePhase[GamePhase["MenuScreenAnimation"] = 1] = "MenuScreenAnimation";
    GamePhase[GamePhase["Intro"] = 2] = "Intro";
    GamePhase[GamePhase["Standard"] = 3] = "Standard";
    GamePhase[GamePhase["Died"] = 4] = "Died";
    GamePhase[GamePhase["GameOver"] = 5] = "GameOver";
    GamePhase[GamePhase["Victory"] = 6] = "Victory";
})(GamePhase || (GamePhase = {}));
export const GameState = {
    phase: GamePhase.Intro,
    timeOnCurrentPhase: 0,
};
